// Register Chart.js components globally
import {
  Chart as ChartJS,
  CategoryScale, // x-axis
  LinearScale, // y-axis
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement, // for pie/doughnut charts
  RadialLinearScale, // for radar/polarArea charts
} from "chart.js";

// Register all components you need globally
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale,
);
